import { Component, ReactNode } from "react";
import { observer } from "mobx-react";

import { Feature } from "@formant/core/model/Feature";
import { ResourcePolicy } from "@formant/core/model/Policies";
import { Resource } from "@formant/core/model/Resource";

import { authStore } from "../../stores";

interface IRestrictedComponentProps<T extends Resource = Resource> {
    resource: Resource;
    requiredAccess?: ResourcePolicy<T>;
    requiredFeature?: Feature;
    children?: ReactNode;
}

@observer
export class RestrictedComponent<
    T extends IRestrictedComponentProps,
> extends Component<T> {
    public render() {
        const { resource, requiredAccess, requiredFeature } = this.props;
        const { userRole } = authStore;

        if (
            userRole &&
            authStore.hasAccess(resource, requiredAccess, requiredFeature)
        ) {
            return this.props.children || false;
        }
        return false;
    }
}
